import scrollToElement from '../../services/scrollTo.js';

export default function(formId, scroll = true) {
  return function() {
    const el = document.querySelector(`#${formId} .is-invalid input`) ||
               document.querySelector(`#${formId} .is-invalid`);

    if (el) {
      if (scroll) {
        scrollToElement(el);
      }
      el.focus();
    }
  };
}
